<template>
  <div class="pie-wrapper">
    <div ref="myPie" class="pie"></div>
    <div class="pie-num">{{ score }}</div>
  </div>
</template>

<script>


export default {
  name: 'pie',
  props: {
    pieData: {
      type: Array,
      default() {
        return [];
      },
    },
    score: [String, Number],
    radius: {
      type: Array,
      default() {
        return ['78%', '100%'];
      },
    },
  },
  data() {
    return {
      colors: {
        1: '#EB5A5A', // <50
        2: '#FAC04C', // 50-80
        3: '#93DA49',
        4: '#F0F0F0', // 默认
        5: '#50EB31', // >80
        6: '#00A0D9'
      },
    };
  },
  watch: {
    score() {
      this.drawPie();
    },
  },
  mounted: function () {
    this.drawPie();
  },
  methods: {
    drawPie() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = this.$echarts.init(this.$refs.myPie);
      // document.getElementById('myPie')
      // 绘制图表
      myChart.setOption({
        color: this.pieData.some(t => t.num > 0) ? this.pieData.map(t => this.colors[`${t.color}`] || '#F0F0F0') : ['#F0F0F0'],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          top: '5%',
          left: 'center',
        },
        series: [
          {
            type: 'pie',
            radius: this.radius,
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold',
              },
              scale: false,
            },

            data: this.pieData.some(t => t.num > 0) ? this.pieData.map(t => ({ value: t.num })) : [{ value: 0 }],
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss">
.pie-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  .pie {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
  .pie-num {
    font-size: 16px;
    color: #1a1a1a;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 12;
  }
}
</style>
